import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@auth-n/authentication.service';
import { authenticationRoutes } from '@auth-n/authentication-routes';
import { InFlightSpinnerComponent } from '@design/spinners/in-flight-spinner/in-flight-spinner.component';

/**
 * Root-host landing point that starts an SSO sign-in for the IDP named in the
 * `idp` query param. Amplify requires the OAuth flow to be initiated from the
 * same origin it completes on (sso-callback, a root-domain route), so flows
 * started on other hosts (e.g. the payroll subdomain) are bounced through here.
 */
@Component({
  selector: 'app-sso-initiate',
  templateUrl: './sso-initiate.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [InFlightSpinnerComponent]
})
export class SsoInitiateComponent {
  constructor(authenticationService: AuthenticationService, route: ActivatedRoute, router: Router) {
    const idp = route.snapshot.queryParamMap.get('idp');

    if (idp) {
      authenticationService.reconfigureAndRedirectToIdp(idp).then((redirectInitiated) => {
        if (!redirectInitiated) {
          router.navigateByUrl(authenticationRoutes.signIn);
        }
      });
    } else {
      router.navigateByUrl(authenticationRoutes.signIn);
    }
  }
}
